import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, UntypedFormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ProDefApeValores } from '@shared/interfaces/request/proDefApeVal';

import { ProDefiniciones } from '@shared/interfaces/request/proDefiniciones';
import { ConceptosService } from '@p-p-portafolio/services/conceptos.service';
import { ProDefinicionesService } from '@p-p-portafolio/services/pro-definiciones.service';
import { TasasService } from '@p-p-portafolio/services/tasas.service';
import { UserService } from '@pages/user/services/user.service';
import { InjectableService } from '@shared/utils/injectable.service';
import { SwalService } from '@shared/utils/swal.service';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { DefinicionesFormComponent } from '../../../definiciones/definiciones-form/definiciones-form.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-def-apertura',
  templateUrl: './def-apertura.component.html',
  styleUrls: ['./def-apertura.component.css']
})
export class DefAperturaComponent implements OnInit {
  //#region Variables

  @Input() modelRecived: ProDefiniciones;
  private _user: string = this._userServices.userCurrent;
  public promocion: string = localStorage.getItem('prom');
  public breakpoint: number;
  public tasas: any[];
  public conceptos: any[];
  public formasPagos: any[];

  //#region Booleanos
  public formPrincipal: boolean = true;
  public selectTasa: boolean;
  public selectCocepto: boolean;
  public loading: boolean;
  //#endregion

  //#endregion

  constructor(
    private _fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<DefinicionesFormComponent>,
    private _swalService: SwalService,
    private _proDefServices: ProDefinicionesService,
    private _userServices: UserService,
    private _injectServices: InjectableService,
    private _tasasServices: TasasService,
    private _conceptosServices: ConceptosService,
    private renderer: Renderer2,
    private _snackBar: MatSnackBar,
    private el: ElementRef
  ) {}

  ngOnInit(): void {
    this.setForm();
    this.readConceptos();
    this.injectConcepto();
    this.readTasas();
    this.injectTasa();
    this.onBreakPonit();
    this.readFormaPago();
  }

  form = this._fb.group({
    promocion: [this.promocion],
    numVar: [
      '',
      {
        validators: [Validators.required, this.variableValidation()],
        asyncValidators: [this.singleDefinicion()],
        updateOn: 'blur'
      }
    ],
    descripcion: ['', Validators.required],
    claveTasa: [''],
    valorFijo: ['0.0', Validators.required],
    amortInf: [1],
    amortSup: ['', Validators.required],
    formula: [''],
    porcentaje: ['0.0', Validators.required],
    concepto: ['', Validators.required],
    conceptoAdicional: [0],
    user: this._user,
    //Campos de otro SP
    iAccion: [0],
    iTipoCalculo: [1]
  });

  //#region ValoresPromocion

  readProDefApeVal(promocion: string, numVar: number) {
    this._proDefServices.readProDefApeVal(promocion, numVar).subscribe((res) => {
      this.form.patchValue({
        iAccion: res.data[0].iAccion,
        iTipoCalculo: res.data[0].iTipoCalculo
      });
    });
  }

  readFormaPago() {
    let iTipo: number = 29;
    this._proDefServices.proDefGasValores(iTipo).subscribe((res) => {
      this.formasPagos = res.data;
    });
  }

  //#endregion

  //#region SelectTabla
  readConceptos() {
    this._conceptosServices.getAll().subscribe((res) => {
      this.conceptos = res;
    });
  }

  injectConcepto() {
    this._injectServices.disparadorConcepto.subscribe((res) => {
      this.form.patchValue({ concepto: res.model.data });
      if (res.model.success) this.changeBoolean('form');
    });
  }

  readTasas() {
    this._tasasServices.read().subscribe((res) => {
      this.tasas = res.data;
    });
  }

  injectTasa() {
    this._injectServices.disparadorTasas.subscribe((res) => {
      this.form.patchValue({ claveTasa: res.model.data });
      if (res.model.success) this.changeBoolean('form');
    });
  }
  //#endregion

  //#region ChangeForm

  changeBoolean(change: string) {
    switch (change) {
      case 'form':
        this.selectCocepto = false;
        this.selectTasa = false;
        this.formPrincipal = true;
        break;
      case 'conceptos':
        this.formPrincipal = false;
        this.selectTasa = false;
        this.selectCocepto = true;
        break;
      case 'tasas':
        this.formPrincipal = false;
        this.selectCocepto = false;
        this.selectTasa = true;
        break;
    }
  }

  //#endregion

  //#region CRUD

  create(model: ProDefiniciones) {
    if (this.form.valid) {
      this.loading = true;
      this._proDefServices.create(model).subscribe((res) => {
        if (res.exito === 1) {
          this.createProDefApeVal(this.form.value);
          this.loading = false;
          this._dialogRef.close();
          this._swalService.success('Agregado');
        } else this._swalService.error('No Agregado');
        this.loading = false;
      });
    } else {
        this._snackBar.open('Debe diligenciar todos los campos correctamente', 'cerrar', { duration: 5000 });
    }
  }

  update(model: ProDefiniciones) {
    if (this.form.valid) {
      let modelApe = this.form.value;
      this.loading = true;
      this._proDefServices.update(model).subscribe((res) => {
        this.updateProDefApeVal(modelApe);
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Editado');
        } else this._swalService.error('No Editado');
      });
    }
  }

  updateProDefApeVal(modelApe: any) {
    let model: ProDefApeValores = {
      sPromocion: modelApe.promocion,
      numVar: modelApe.numVar,
      iAccion: modelApe.iAccion,
      iTipoCalculo: modelApe.iTipoCalculo,
      iCobrar: 0
    };
    this._proDefServices.updateProDefApeVal(model).subscribe();
  }

  createProDefApeVal(modelApe: any) {
    const model: ProDefApeValores = {
      sPromocion: modelApe.promocion,
      numVar: modelApe.numVar,
      iAccion: modelApe.iAccion,
      iTipoCalculo: modelApe.iTipoCalculo,
      iCobrar: 0
    };
    this._proDefServices.createProDefApeVal(model).subscribe();
  }

  //#endregion

  //#region Get Fb
  formValue(value: string) {
    return this.form.get(value);
  }
  //#endregion

  //#region Validations
  variableValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const variable = control.value;
      if (variable == null || variable === '') return null;
      if (variable >= 3 && variable <= 99) {
        return null;
      }

      this._snackBar.open('El rango de variables para Apertura es de 3 a 99', 'cerrar', { duration: 5000 });
      const input = this.el.nativeElement.querySelector('#numVar');
      if (input) {
        this.renderer.addClass(input, 'is-invalid');
      }

      return { variableValidation: true };
    };
  }

  //#endregion

  //#region AsyncValidations

  singleDefinicion(): AsyncValidatorFn {
    console.log(this.modelRecived);
    return (control: AbstractControl): Observable<ValidationErrors | any> => {
      if (this.modelRecived) return of(null);

      return this._proDefServices.readOne(this.promocion, control.value).pipe(
        tap(() => {
          const input = this.el.nativeElement.querySelector('#numVar');
          this.renderer.removeClass(input, 'is-invalid');
        }),
        map((res) => {
          const input = this.el.nativeElement.querySelector('#numVar');
          // 1 → la promoción no existe  ⇒  VÁLIDA
          if (res.exito === 1) {
            this.renderer.addClass(input, 'is-invalid'); // aura roja
            this._snackBar.open('Variable en uso, intente con otra.', 'cerrar', { duration: 5000 });
            return { singleDefinicion: true }; // ← objeto de error
          }
          // distinto de 1 → libre  ⇒  INVÁLIDA
          return null; // ← sin errores
        })
      );
    };
  }
  //#endregion

  //#region Options

  setForm(): void {
    if (this.modelRecived) {
      let model: ProDefiniciones = this.modelRecived;
      this.readProDefApeVal(model.promocion, model.numVar);
      const setModel = {
        promocion: model.promocion,
        numVar: model.numVar,
        descripcion: model.descripcion,
        claveTasa: model.claveTasa,
        valorFijo: model.valorFijo,
        amortInf: model.amortInf,
        amortSup: model.amortSup,
        formula: model.formula,
        porcentaje: model.porcentaje,
        concepto: model.concepto,
        conceptoAdicional: model.conceptoAdicional,
        user: this._user
      };
      this.form.patchValue(setModel);
    }
  }

  onBreakPonit() {
    this.breakpoint = window.innerWidth <= 400 ? 1 : 2;
  }

  onResize(event) {
    this.breakpoint = event.target.innerWidth <= 400 ? 1 : 2;
  }

  close() {
    this._dialogRef.close();
  }

  //#endregion
}
